"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _bwaRedirectInfo = require("../../apis/bwa/widgets/bwa-redirect-info");
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
var _katalFunnelEvents = require("../../events/katal-funnel-events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var WIDGET_ID_PREFIX = 'bwa-redirect-info-widget';
var CART_CREATE_TIMEOUT_MS = 8000;
var BwaRedirectInfoWidgetRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaRedirectInfoWidgetRenderHandler(_ref) {
    var _this;
    var buttonSelector = _ref.buttonSelector,
      useMutationObserver = _ref.useMutationObserver,
      _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden;
    (0, _classCallCheck2["default"])(this, BwaRedirectInfoWidgetRenderHandler);
    _this = _callSuper(this, BwaRedirectInfoWidgetRenderHandler);
    _this.buttonSelector = buttonSelector;
    _this.useMutationObserver = useMutationObserver !== null && useMutationObserver !== void 0 ? useMutationObserver : false;
    _this.firstIframeId = null;
    _this.iframeResolved = null;
    _this.isHidden = isHidden;
    _this.iframes = [];
    _this.tInjected = null;
    _this.perceivedLogged = false;
    return _this;
  }
  (0, _inherits2["default"])(BwaRedirectInfoWidgetRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaRedirectInfoWidgetRenderHandler, [{
    key: "show",
    value: function show() {
      this.isHidden = false;
      this.iframes.forEach(function (iframe) {
        iframe.style.display = '';
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.isHidden = true;
      this.iframes.forEach(function (iframe) {
        iframe.style.display = 'none';
      });
    }
  }, {
    key: "applyRepeatCustomerVisibility",
    value: function applyRepeatCustomerVisibility() {
      var _this2 = this;
      // Embedded/Cognito checkout has no redirect — keep the widget hidden (but in DOM for its relay JS).
      if ((0, _utils.isEmbeddedCheckoutEnabled)()) return;
      var cachedRepeatCustomer = sessionStorage.getItem(_constants.SESSION_STORAGE_KEYS.IS_BWA_REPEAT_CUSTOMER);
      if (cachedRepeatCustomer !== null) {
        if (cachedRepeatCustomer === "true") this.hide();else this.show();
        return;
      }
      var bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
      var _handler = function handler(event) {
        var _event$data, _event$data2;
        if (event.origin !== bwaOrigin) return;
        if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.widgetId) !== _constants.IFRAME_IDS.EMPTY_WIDGET) return;
        if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.widgetMessageType) !== _constants.EVENT_TYPE.CUSTOM.BWA_REPEAT_CUSTOMER_RESOLVED) return;
        window.removeEventListener('message', _handler);
        if (event.data.isBwARepeatCustomer) _this2.hide();else _this2.show();
      };
      window.addEventListener('message', _handler);
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this3 = this;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.injectRedirectInfoWidget();
              this.setupMessageListener();
              if (this.useMutationObserver) {
                new MutationObserver(function () {
                  return _this3.injectRedirectInfoWidget();
                }).observe(document.body, {
                  childList: true,
                  subtree: true
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "injectRedirectInfoWidget",
    value: function injectRedirectInfoWidget() {
      var _this4 = this;
      var buttons = (0, _utils.safeQuerySelectorAll)(this.buttonSelector);
      buttons.forEach(function (button, index) {
        var iframeId = "".concat(WIDGET_ID_PREFIX, "-").concat(button.id || "".concat(_this4.buttonSelector, "-").concat(index));
        if (document.getElementById(iframeId)) return;
        var buttonWidth = button.getBoundingClientRect().width || button.offsetWidth;
        if (buttonWidth === 0) return;
        var iframe = (0, _bwaRedirectInfo.bwaRedirectInfoWidget)(iframeId, _constants.CSS_CLASSES.REDIRECT_INFO_WIDGET);
        iframe.style.width = "".concat(buttonWidth, "px");
        var buttonParent = button.parentElement;
        var _resolveWidgetAnchor = (0, _utils.resolveWidgetAnchor)(button),
          anchor = _resolveWidgetAnchor.anchor,
          escaped = _resolveWidgetAnchor.escaped;
        if (escaped && buttonParent && !buttonParent.tagName.includes('-')) {
          (0, _utils.alignWidgetBelowButtonRow)(iframe, buttonParent, buttonWidth);
        }
        (0, _utils.normalizeWidgetGap)(iframe, anchor);
        if (_this4.isHidden) iframe.style.display = 'none';
        anchor.insertAdjacentElement('afterend', iframe);
        _this4.iframes.push(iframe);
        if (!_this4.firstIframeId) {
          _this4.firstIframeId = iframeId;
          // Anchor timing on the first button-anchored iframe; later ones are duplicates.
          _this4.tInjected = performance.now();
          _this4.iframeResolved = new Promise(function (resolve) {
            iframe.addEventListener('load', function () {
              return resolve();
            });
          });
        }

        // Skip when width is managed by alignWidgetBelowButtonRow.
        if (!(0, _utils.isWidgetWidthManagedByParent)(iframe, buttonParent)) {
          var resizeObserver = new ResizeObserver(function () {
            iframe.style.width = "".concat(button.getBoundingClientRect().width || button.offsetWidth, "px");
          });
          resizeObserver.observe(button);
          requestAnimationFrame(function () {
            iframe.style.width = "".concat(button.getBoundingClientRect().width || button.offsetWidth, "px");
          });
        }
      });
    }

    // Guarantees a working same-origin relay iframe exists before we postMessage to it. The
    // per-button injection is skipped while a button has zero width (e.g. a checkout button inside a
    // closed side-cart drawer), and the MutationObserver only reacts to childList changes — so the
    // relay can be missing at click time. Re-try the button injection (the drawer is open on click),
    // then fall back to a detached hidden relay so cart creation never silently no-ops.
  }, {
    key: "ensureRelayReady",
    value: function () {
      var _ensureRelayReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.firstIframeId) this.injectRedirectInfoWidget();
              if (!this.firstIframeId) this.injectHiddenRelay();
              _context2.next = 4;
              return this.iframeResolved;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function ensureRelayReady() {
        return _ensureRelayReady.apply(this, arguments);
      }
      return ensureRelayReady;
    }() // Detached, display:none relay iframe (not anchored to any button). Used only as the same-origin
    // postMessage channel for cart creation when no button-anchored widget could be created.
  }, {
    key: "injectHiddenRelay",
    value: function injectHiddenRelay() {
      if (this.firstIframeId) return;
      var iframeId = "".concat(WIDGET_ID_PREFIX, "-relay");
      var existing = document.getElementById(iframeId);
      if (existing) {
        this.firstIframeId = iframeId;
        return;
      }
      var iframe = (0, _bwaRedirectInfo.bwaRedirectInfoWidget)(iframeId, _constants.CSS_CLASSES.REDIRECT_INFO_WIDGET);
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      this.iframes.push(iframe);
      this.firstIframeId = iframeId;
      this.iframeResolved = new Promise(function (resolve) {
        iframe.addEventListener('load', function () {
          return resolve();
        });
      });
    }
  }, {
    key: "setupMessageListener",
    value: function setupMessageListener() {
      var _this5 = this;
      window.addEventListener("message", function (event) {
        var _event$data3, _event$data4, _event$data5;
        var bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
        if (event.origin !== bwaOrigin) return;
        if (((_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.type) === _constants.EVENT_TYPE.CUSTOM.BWA_REDIRECT_INFO_RENDERED) {
          // Match the message to the specific iframe that sent it
          document.querySelectorAll("[id^=\"".concat(WIDGET_ID_PREFIX, "\"]")).forEach(function (iframe) {
            if (iframe.contentWindow === event.source) {
              iframe.style.height = event.data.height + "px";
            }
          });
          if (!_this5.perceivedLogged) {
            _this5.perceivedLogged = true;
            (0, _katalFunnelEvents.logPerceived)("redirect_info", {
              tInjected: _this5.tInjected,
              signalType: "content_visible"
            });
          }
        } else if (((_event$data4 = event.data) === null || _event$data4 === void 0 ? void 0 : _event$data4.type) === _constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_FAILED) {
          var _this5$onCheckoutFail;
          (_this5$onCheckoutFail = _this5.onCheckoutFailed) === null || _this5$onCheckoutFail === void 0 || _this5$onCheckoutFail.call(_this5);
        } else if (((_event$data5 = event.data) === null || _event$data5 === void 0 ? void 0 : _event$data5.type) === 'bwa-navigate-to-checkout') {
          window.location.href = event.data.url;
        }
      });
    }
  }, {
    key: "setOnCheckoutFailed",
    value: function setOnCheckoutFailed(callback) {
      this.onCheckoutFailed = callback;
    }
  }, {
    key: "sendCheckoutMessage",
    value: function () {
      var _sendCheckoutMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref2) {
        var cartDetails, storeUrl, storeId, buttonId, message;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              cartDetails = _ref2.cartDetails, storeUrl = _ref2.storeUrl, storeId = _ref2.storeId, buttonId = _ref2.buttonId;
              _context3.next = 3;
              return this.ensureRelayReady();
            case 3:
              message = (0, _utils.buildCheckoutMessage)({
                cartDetails: cartDetails,
                storeUrl: storeUrl,
                storeId: storeId,
                ecp: _constants.ECP,
                extraFields: {
                  buttonId: buttonId,
                  navigateFromParent: true
                }
              });
              (0, _utils.postMessageToIframe)(this.firstIframeId, message);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function sendCheckoutMessage(_x) {
        return _sendCheckoutMessage.apply(this, arguments);
      }
      return sendCheckoutMessage;
    }() // Embedded checkout: ask the same-origin iframe to create the cart and return the
    // checkoutId + returnUrl (no navigation). Resolves with { checkoutId, returnUrl }.
  }, {
    key: "triggerCartCreation",
    value: function () {
      var _triggerCartCreation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref3) {
        var _this6 = this;
        var cartDetails, storeUrl, storeId, bwaOrigin, message;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              cartDetails = _ref3.cartDetails, storeUrl = _ref3.storeUrl, storeId = _ref3.storeId;
              _context4.next = 3;
              return this.ensureRelayReady();
            case 3:
              bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
              message = (0, _utils.buildCheckoutMessage)({
                cartDetails: cartDetails,
                storeUrl: storeUrl,
                storeId: storeId,
                ecp: _constants.ECP,
                extraFields: {
                  type: _constants.EVENT_TYPE.CUSTOM.BWA_CART_CREATE_REQUEST
                }
              });
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                var _handler2 = function handler(event) {
                  var _event$data6, _event$data7;
                  if (event.origin !== bwaOrigin) return;
                  if (((_event$data6 = event.data) === null || _event$data6 === void 0 ? void 0 : _event$data6.type) === _constants.EVENT_TYPE.CUSTOM.BWA_CART_CREATE_RESPONSE) {
                    clearTimeout(timer);
                    window.removeEventListener('message', _handler2);
                    resolve({
                      checkoutId: event.data.checkoutId,
                      returnUrl: event.data.returnUrl
                    });
                  } else if (((_event$data7 = event.data) === null || _event$data7 === void 0 ? void 0 : _event$data7.type) === _constants.EVENT_TYPE.CUSTOM.BWA_CHECKOUT_FAILED) {
                    clearTimeout(timer);
                    window.removeEventListener('message', _handler2);
                    reject(new Error(event.data.error || 'Cart creation failed'));
                  }
                };
                // Don't hang the checkout button if the iframe never responds (e.g. create-cart stalls).
                var timer = setTimeout(function () {
                  window.removeEventListener('message', _handler2);
                  reject(new Error('Cart creation timed out'));
                }, CART_CREATE_TIMEOUT_MS);
                window.addEventListener('message', _handler2);
                (0, _utils.postMessageToIframe)(_this6.firstIframeId, message);
              }));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function triggerCartCreation(_x2) {
        return _triggerCartCreation.apply(this, arguments);
      }
      return triggerCartCreation;
    }()
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-redirect-info-widget-render-handler.js.map
